/**
 * The house modal, shared by the dialog and the alert dialog. The overlay
 * centres the card and holds the gutter, so the card keeps its content's
 * height, capped by the window. It does not animate.
 */
export const MODAL_OVERLAY =
  "fixed inset-0 z-50 flex items-center justify-center bg-overlay p-6";

export const MODAL_SURFACE =
  "relative grid max-h-full w-full max-w-[440px] gap-4 overflow-y-auto rounded-lg border border-border bg-card px-[22px] pt-[22px] pb-[18px] shadow-dialog";

export const MODAL_TITLE =
  "text-[17px] leading-[1.3] font-bold tracking-[-0.01em]";

export const MODAL_DESCRIPTION =
  "text-detail leading-normal text-muted-foreground";

// 22px under the body: the grid's 16 and six more. The design's modal buttons
// are a size of their own, roomier than a row's, so the foot sets them.
export const MODAL_ACTIONS =
  "flex flex-wrap justify-end gap-[9px] pt-1.5 [&_button]:h-auto [&_button]:rounded-inset [&_button]:px-4 [&_button]:py-[9px] [&_button]:text-detail";
